import { Box, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { SmartLink } from "../../../components/Link";
import { Text } from "../../../components/common/typography/Style";
import { _url } from "../../../config/utils";
import { IS_USA_SITE } from "../../../constants";
import { useLocale } from "../../../hooks/locale";
import { ColorTheme } from "../../../styles/color";
import { getSiteValueByLocaleId } from "../../../utils/SiteUtils";
import { sideMenu } from "./util";

const buildUrl = (item, { webflowHomepageUrl }) => {
	switch (item.type) {
		case "managed": {
			return `${webflowHomepageUrl}${item.url}`;
		}
		default: {
			if (item.url === "/bookings") {
				const locale = useLocale();
				if (
					["CAD", "GBP", "AUD", "USD"].includes(locale.currencyCode) &&
					locale.portalUrl
				) {
					return `${locale.portalUrl}/bookings`;
				}
				return `${locale.pathPrefix}/bookings`;
			}
			return item.url;
		}
	}
};

const RedesignFooter = () => {
	const navigate = useNavigate();
	const { localeId, webflowHomepageUrl } = useLocale();

	return (
		<Grid
			py={"56px"}
			justifyContent={"center"}
			container
			bgcolor={ColorTheme.grayNeutral[800]}
		>
			<Grid item xs={12} md={10} px={"16px"}>
				<Grid
					container
					pb={"80px"}
					borderBottom={`1px solid ${ColorTheme.grayNeutral[600]}`}
				>
					<Grid item xs={12} md={6}>
						<Grid container>
							<Grid item xs={12} mb={"40px"}>
								<img
									src={_url("assets/redesign/icons/footer_logo.svg")}
									alt={"Logo"}
								/>
							</Grid>
							<Grid item xs={12} mt={"8px"}>
								<Text
									textcolor={ColorTheme.base.white}
									size={"sm"}
									textweight={"regular"}
								>
									We're here to help!&nbsp;
									<span
										onClick={() => {
											if (window.Intercom) {
												window.Intercom("show");
											}
										}}
										style={{
											color: ColorTheme.secondary[600],
											cursor: "pointer",
										}}
									>
										Chat with us
									</span>{" "}
									now for the fastest response.
								</Text>
							</Grid>
							<Grid item xs={12} mt={"8px"}>
								<Text
									textcolor={ColorTheme.base.white}
									size={"sm"}
									textweight={"regular"}
								>
									You can also email{" "}
									<span
										onClick={() =>
											window.open(
												`mailto:${getSiteValueByLocaleId("supportMail")}`,
												"_blank",
											)
										}
										style={{
											color: ColorTheme.secondary[600],
											cursor: "pointer",
										}}
									>
										{getSiteValueByLocaleId("supportMail")}
									</span>
									, but responses may take longer.
								</Text>
							</Grid>
							<Grid item xs={12} mt={"40px"}>
								{
									<img
										width={"100%"}
										src={getSiteValueByLocaleId("footerBrands")}
									/>
								}
							</Grid>
						</Grid>
					</Grid>
					<Grid item xs={12} md={6} mt={["40px", "40px", "0px"]}>
						<Grid container columnSpacing={"40px"}>
							{sideMenu.map((item, index) => (
								<Grid item xs={6} md={4} key={item.id}>
									<Text
										mt={[
											item.id === 11 ? "24px" : "0",
											item.id === 11 ? "24px" : "0",
											"0",
										]}
										textcolor={ColorTheme.base.white}
										size={"md"}
										textweight={"bold"}
									>
										{item.title}
									</Text>
									<Box
										display={[
											item.id === 11 ? "flex" : "block",
											item.id === 11 ? "flex" : "block",
											"block",
										]}
										gap={[
											item.id === 11 ? "40px" : "0",
											item.id === 11 ? "40px" : "0",
											"0",
										]}
									>
										{item.subMenu.map((sub) => (
											<SmartLink
												key={sub.id}
												href={buildUrl(sub, { webflowHomepageUrl })}
												target={sub.type === "external" ? "_blank" : undefined}
												rel={sub.type === "external" ? "noreferrer" : undefined}
											>
												<Box
													sx={{ cursor: "pointer" }}
													display={"flex"}
													mt={"16px"}
													gap={"12px"}
													alignItems={"center"}
												>
													{sub.icon && (
														<img
															style={{ height: 20, width: 20 }}
															src={_url(`assets/redesign/icons/${sub.icon}`)}
														/>
													)}
													<Text
														textcolor={ColorTheme.grayNeutral[300]}
														size={"sm"}
														textweight={"regular"}
													>
														{sub.title}
													</Text>
												</Box>
											</SmartLink>
										))}
									</Box>
								</Grid>
							))}
						</Grid>
					</Grid>
				</Grid>
				<Text
					mt={"16px"}
					size={"sm"}
					textweight={"regular"}
					textcolor={ColorTheme.grayNeutral[400]}
					textAlign={"center"}
				>
					© 2024 PayLater Travel. All rights reserved. <br />
					Partnered with:{" "}
					<a href="http://slicepay.travel/#/for-customers">Slice Pay</a> and{" "}
					<a href="http://slicepay.travel/#/for-travel-agents">
						Slice Pay Instalments for Travel Agents
					</a>
					{IS_USA_SITE && (
						<>
							{" | "}
							<span
								onClick={() => window.revisitCkyConsent?.()}
								style={{ cursor: "pointer" }}
							>
								Do Not Sell My Personal Information
							</span>
						</>
					)}
				</Text>
			</Grid>
		</Grid>
	);
};

export default RedesignFooter;
